import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface ConfirmationDialogData {
  title?: string;
  description?: string;
  imageUrl?: string;
  confirmBtnText?: string;
  confirmBtnColor?: string;
  onConfirmation?: () => void;
  cancel?: () => void;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  standalone: false,
})

/**
 * usage example:
 *     this.dialog.open(DeleteConfirmationComponent, {
 *       width: '700px',
 *       height: '400px',
 *       data: {
 *         onConfirmation: () => {
 *           console.log('Confirmed!');
 *         }
 *       }
 *     });
 */
export class ConfirmationDialogComponent implements OnInit {
  dir: string;
  title = 'Confirm?';
  description = 'Are you sure?';
  confirmationImage = '';
  confirmBtnText = 'Delete';
  confirmBtnColor = 'warn';
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData,
  ) {}

  ngOnInit(): void {
    this.dir = localStorage.getItem('html-dir');
    this.title = this.data.title || this.title;
    this.description = this.data.description || this.description;
    this.confirmationImage = this.data.imageUrl;
    this.confirmBtnText = this.data.confirmBtnText || this.confirmBtnText;
    this.confirmBtnColor = this.data.confirmBtnColor || this.confirmBtnColor;
  }

  confirm() {
    if (this.data && this.data.onConfirmation) {
      this.data.onConfirmation();
    }
    this.dialogRef.close();
  }

  cancel() {
    this.data?.cancel?.();
    this.dialogRef.close();
  }
}
